import { PrintOptionActions } from '@/components/modals/Print/types';
import type { QuoteContent } from '@/features/Quotes/types';
import {
  VersicherungsangabenLoadResponse,
  VersicherungsangabenCreateResponse,
} from '@/features/Versicherungsangaben/types';
import type { HttpClientResponse } from '@/services/api/HttpClient';
import { HttpService } from '@/services/api/HttpService';

export class VersicherungsangabenHttpService extends HttpService {
  storeVersicherungsangaben(
    clientId: number,
    title: string,
    content: QuoteContent,
    mail: PrintOptionActions['pdfEmail'],
  ): HttpClientResponse<VersicherungsangabenCreateResponse> {
    return this.httpClient.post('angebot/versicherungsangaben', {
      data: {
        clientId,
        title,
        content,
        mail,
      },
    });
  }

  loadVersicherungsangabenById(
    id: string,
  ): HttpClientResponse<VersicherungsangabenLoadResponse> {
    return this.httpClient.get(`angebot/versicherungsangaben/${id}`);
  }

  updateVersicherungsangaben(
    id: number,
    close: boolean,
    clientId: number,
    title: string,
    content: QuoteContent,
  ): HttpClientResponse<null> {
    return this.httpClient.patch(`angebot/versicherungsangaben/${id}`, {
      data: {
        close,
        clientId,
        title,
        content,
      },
    });
  }
}
